import React, { ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { CreateUpdateInvoiceModal } from 'modules/invoice';
import { DocuSignDialog } from 'modules/integrations/docuSign';
import { CreateProposalProductDialog } from 'modules/proposals';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { UploadImagesForExistingEquipmentDialog, PreviewExistingImagesDialog } from 'modules/equipment';
import { ActivityDialog, CallActivityDialog, NoteActivityDialog } from 'modules/dealActivity';
import { FinanceProgramModal, PreviewFinanceProgramModal } from 'modules/financeProgram';

import PageOpportunityDetails from './PageOpportunityDetails';

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.DocuSignDialog]: <DocuSignDialog />,
  [ModalsKeys.FinanceForm]: <FinanceProgramModal />,
  [ModalsKeys.ActivityDialog]: <ActivityDialog />,
  [ModalsKeys.CallActivityDialog]: <CallActivityDialog />,
  [ModalsKeys.NoteActivityDialog]: <NoteActivityDialog />,
  [ModalsKeys.PreviewFinanceForm]: <PreviewFinanceProgramModal />,
  [ModalsKeys.UploadImagesForExistingEquipmentDialog]: <UploadImagesForExistingEquipmentDialog />,
  [ModalsKeys.PreviewExistingEquipmentImagesDialog]: <PreviewExistingImagesDialog />,
  [ModalsKeys.CreateUpdateInvoiceDialog]: <CreateUpdateInvoiceModal />,
  [ModalsKeys.ProposalCreateProductDialog]: <CreateProposalProductDialog />,
};

export const PageOpportunityDetailsContainer = () => (
  <PageContainer modals={modalsWithKeys} title="Opportunity Details">
    <PageOpportunityDetails />
  </PageContainer>
);
